import { IBoundaryDataItem } from '@/interfaces/powerMarkets/maps/IZonalData.ts';

export function getMaximumConstrainedPercentage (boundaryData: IBoundaryDataItem): number | null {
    const constraintValues = Object.values(boundaryData.relatedConstraints)
        .filter(constraintValue => constraintValue !== 0);

    if (!constraintValues.length) return null;

    return Math.max(...constraintValues.map(constraintValue => (
        (Math.abs(boundaryData.value) / Math.abs(constraintValue)) * 100
    )));
}

export function getConstrainedPercentageColour (percentage: number | null): string {
    if (percentage === null) return 'rgb(89, 89, 154)';

    const clampedPercentage = Math.min(percentage, 200);
    const red = clampedPercentage <= 100
        ? Math.round((255 * clampedPercentage) / 100)
        : 255;
    const green = clampedPercentage <= 50
        ? 180
        : Math.round(180 * (1 - ((clampedPercentage - 50) / 150)));

    return `rgb(${red}, ${Math.max(green, 0)}, 40)`;
}
